import React, { useMemo } from 'react';
import { useIntl } from 'umi';
import TableCommonHook from '@op/components/TableCommonHook';
import { decimalFormatPercentage, reviewsFormat } from '@op/utils/value';
import { TableColumn } from 'tea-component';

interface ITable {
  filter: any;
  records: Array<any>;
  height?: number;
  type?: string;
  translate: (value: string) => string;
}

export default function LanguageTable(props: ITable) {
  const { records = [], height = 300, type, translate } = props;

  const { formatMessage } = useIntl();

  const tableColumns = useMemo(() => {
    const columns: TableColumn[] = [
      {
        key: 'name',
        header: formatMessage({ id: 'Language' }),
        align: 'left',
        width: 150,
        render: (cvm: any) => translate(cvm.language),
      },
      {
        key: 'count',
        header: formatMessage({ id: 'Total Mentions' }),
        render: (cvm: any) => reviewsFormat(cvm.all_reviews),
        align: 'right',
        width: 150,
      },
      {
        key: 'positive',
        header: formatMessage({ id: 'All Reviews Positive%' }),
        render: (cvm: any) => decimalFormatPercentage(cvm.positive),
        align: 'right',
        width: 200,
      },
      {
        key: 'negative',
        header: formatMessage({ id: 'All Reviews Negative%' }),
        render: (cvm: any) => decimalFormatPercentage(cvm.negative),
        align: 'right',
        width: 220,
      },
    ];

    return columns;
  }, [formatMessage]);

  return (
    <TableCommonHook
      recordKey={'key'}
      columns={tableColumns}
      total={records?.length || 0}
      records={records || []}
      hasPageable={false}
      maxHeight={height - 30}
      minWidth={'auto'}
      style={{ height }}
    />
  );
}
